import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { JA_APOSTILLE } from "@/data/ja-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ja/apostille";
const C = JA_APOSTILLE;

export const Route = createFileRoute("/ja/apostille")({
  head: () => ({
    meta: [
      { title: ctaTitle("タイ・アポスティーユ代行 | NYC Legal バンコク(日本語対応)", "/ja/apostille", "th")},
      { name: "description", content: ctaDesc("バンコクのアポスティーユ代行:タイ MFA ハーグ認証 + 公証 + 認証翻訳を 5〜7 営業日で。日本人スタッフが LINE で日本語対応。. Talk to a specialist today; no obligation, fast reply.", "/ja/apostille", "th")},
      { property: "og:title", content: ctaTitle("タイ・アポスティーユ代行(日本語) | NYC Legal", "/ja/apostille", "th")},
      { property: "og:description", content: ctaDesc("日タイ双方向アポスティーユをワンストップで。LINE で日本語見積。", "/ja/apostille", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ja_JP" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/apostille" },
          { hreflang: "en", path: "/en/apostille" },
          { hreflang: "zh", path: "/zh/apostille" },
          { hreflang: "ja", path: "/ja/apostille" },
          { hreflang: "x-default", path: "/apostille" },
        ],
        "/apostille",
      ),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LegalService",
          name: "NYC Legal — タイ・アポスティーユ",
          url: `${SEO_SITE}${PATH}`,
          areaServed: ["TH", "JP"],
          inLanguage: "ja",
          priceRange: "฿1,500–฿5,000",
          serviceType: "Apostille Service · MFA Legalisation",
          provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "ja",
          mainEntity: C.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "HowTo",
          inLanguage: "ja",
          name: "タイ・アポスティーユ取得の流れ",
          totalTime: "P7D",
          estimatedCost: { "@type": "MonetaryAmount", currency: "THB", value: "1500" },
          step: C.steps.map((s) => ({ "@type": "HowToStep", name: s.name, text: s.text })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "ホーム", item: `${SEO_SITE}/ja` },
            { "@type": "ListItem", position: 2, name: "アポスティーユ", item: `${SEO_SITE}${PATH}` },
          ],
        }),
      },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
